module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch2",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CN",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "18",
      "id": "pg_18",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter 2")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Fallon tried to convince herself that it was just a business/thank-you dinner. Not even changing her dress twice before settling on an off-the-shoulder raspberry-colored dress convinced her otherwise, nor did the three changes of sandals and earrings. However, she gave up trying the moment she saw Lance, tall and mouthwateringly delicious, waiting outside the restaurant for her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her heart did a crazy jitterbug; her legs weren’t quite as steady as they’d been moments earlier. He stood a few feet from the long line of people waiting to enter the Red Cactus.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She was ten minutes early. She’d told herself it was to allow time to park and not because she was anxious to see him again. She rolled her eyes. It was bad when you started lying to yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lance reached her in seconds, his dark brows furrowed. “Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So he was perceptive. “Just thinking,” she said. At least that was the truth. “I tried to make reservations, but they were booked. You want to wait?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "19",
      "id": "pg_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“I admit, I’m not the patient type when waiting for a table,” he told her. “Fortunately, I took the precaution of calling and making reservations, just in case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She smiled up at him. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Long, lean fingers gently took her arm. Her skin heated, tingled.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They continued inside the restaurant, past the stares of those waiting in line. Fallon was almost compelled to explain that they weren’t cutting, they had reservations.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lance didn’t appear to notice. He stopped in front of the hostess’s podium. “Reservations for Saxton at seven.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The pretty young woman in a slim-fitting black dress smiled and picked up two oversized menus with red boots and cacti on the front. “Certainly, Mr. Saxton. If you and your guests will follow Lacy, she’ll seat you at your table.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Smiling, Lacy accepted the menus. “This way, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lance’s hand moved to the small of Fallon’s back and she almost yelped. Heat radiated through the cotton fabric as if on bare skin. Lance could really be a problem—if she let him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Here you are,” Lacy said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lance pulled out a chair at the table for two for Fallon, took the seat across from her, and accepted the menu. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your waiter, Shawn, should be with you shortly. Can I get you anything to drink?” Lacy asked. “Wine, cocktail, or flavored tea perhaps?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "20",
      "id": "pg_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Fallon?” Lance asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon wasn’t much for alcohol, but tonight seemed to be the one to be a little daring. “Black mojita.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Pomegranate iced tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll get those right out,” Lacy said, and left.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon propped her arms on the table and hoped she wasn’t too obvious, but the man certainly was easy on the eyes. “How are things shaping up for the auction?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Good. The catalog with the most expensive pieces arrived this morning,” he told her. “The employees you saw this afternoon are finishing up listing the smaller items.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“From what I saw, you all have a humongous task ahead of you,” she said. “The glassware alone is extensive and impressive.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It will get done.” The words were clipped, final.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon believed him. Lance wasn’t a man who impressed her as tolerating excuses—and that included himself. “Then you deserve a night to relax. Have you eaten here before?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No. I spent summers here growing up, but I haven’t been back since I graduated from college.” He glanced around the crowded restaurant. “Brandon has done well for himself. I hear the food is delicious, but I guess you can tell from the long line and the restaurant being booked.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ve seldom tasted better,” she told him. “One of the first stories I did on Santa Fe was on the Red Cactus.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "21",
      "id": "pg_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“How long have you been a travel writer?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Since my junior year at college,” she related. “I get to travel to exciting places and get paid for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His dark head tilted to one side. “But I don’t think money is your motivating reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Surprised delight swept through her. “It’s not.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your drinks. I’m Shawn. I’ll be your waiter.” A tall, slender man dressed in a white shirt and black pants placed the glasses in front of them and took out a pad and pencil. “Are you ready to order or do you need a few more minutes?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fallon?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I already know I want the triple sampler and the onion rings, but I don’t think you’ve had time to study the menu.” Fallon closed her menu.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lance opened the menu, briefly glanced at it, and said, “I’ll have the porterhouse, medium, with a baked potato, butter only, asparagus, and house salad with ranch dressing.” Lance handed the man his menu.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Frowning, Fallon followed suit. “How did you do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Speed-reading.” Lance picked up his drink. “So what drives you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She realized two things: Lance didn’t want to talk about himself, and there was definitely more to him than his sexy good looks. “Growing up in Austin, I dreamed of being a news correspondent and traveling all over the world.” Her fingers closed around the stem of the glass. “When that didn’t "), _c('span', {
    attrs: {
      "aria-label": "22",
      "id": "pg_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("work out, this sort of just happened when a magazine wanted a fresh article on Austin. The story led to another and another. By the time I graduated from college, I had logged a lot of miles on my mother’s car and written over fifty articles. I like traveling and discovering things people might have overlooked. After graduation, I just kept going and writing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Where were you before you came here?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Where the rich and famous play, Martha’s Vineyard.” She laughed. “Besides the historic fishing villages, it has breezy beaches, adorable towns, delicious food. The lobster was out of this world.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He gazed at her over his glass. “The wealthy are here as well. Is that what drew you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No,” she answered. She would not be miffed with him. “People and places draw me. Martha’s Vineyard and here can be expensive, but both can be enjoyed by families on a budget, one of the things I take great care to point out.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He placed his glass aside. “You’re different.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Good or bad?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I haven’t figured it out,” he said, staring at her intently.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Butterflies took flight in Fallon’s stomach. She reminded herself that she was leaving in less than a week and hoped she listened.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your food.” The waiter served them both. “Is there anything else I can get either of you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fallon?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "23",
      "id": "pg_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Fallon mentally shook herself and looked at her plate. “I’m good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Same here. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon tucked her head to bless the food, then reminded herself this was a thank-you dinner. Finished, she reached for her quesadilla and took a generous bite. Moaned. Savored. She did love good food. When she opened her eyes Lance was staring at her. The heat in his eyes almost singed her. He wasn’t being distant now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He broke contact first and reached for his knife and fork. “Why didn’t the news correspondent dream work out?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon wondered how he could revert back to being impersonal after eating her with his eyes, then realized it took practice. But why would he have learned such self-control? Her natural curiosity to see what others didn’t kicked in.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He looked up when she didn’t answer. “I hope I’m not being too personal.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She reached for her drink. She sipped and studied him over the rim of her highball glass. He didn’t fidget, just kept her gaze. That took practice as well. There was definitely more to Lance than met the eye. Perhaps he deserved the whole story, but not tonight. “Something tells me you wouldn’t care if you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The corners of his sensual mouth quirked. “How is your food?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Delicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s always good to hear.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "24",
      "id": "pg_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Fallon glanced up to see Brandon Grayson, owner of the Red Cactus, a wide grin on his handsome face. “You couldn’t cook a bad dish if you tried.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon’s grin widened. “If you ever have trouble getting a table, ask the hostess to find me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll do that,” Fallon said, pleased. She’d met Lance and Brandon at a late luncheon at his wife’s family-owned hotel, "), _c('i', [_vm._v("Casa de Serenidad")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon shook Lance’s outstretched hand. “Good seeing you again.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lance nodded toward Fallon. “Thank Fallon. She suggested we eat here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But Lance was smart enough to get reservations,” she said, amused. “So this is a joint effort.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Faith taught me that two is always better than one.” Brandon glanced between Lance and Fallon.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon hoped she wasn’t blushing. She didn’t dare look at Lance. “Your wife is wonderful. Naomi is so excited about the wedding reception at her hotel. She still can’t believe she and Richard were able to obtain one of the smaller ballrooms.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nothing Faith likes better than planning events for special friends and family.” Brandon shook his dark head, the long braid hanging down his back moving sensuously. “She, Mama, and Catherine were on the phone early this morning talking about place settings and flower arrangements for the tables.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“This morning Richard and Naomi were going over the final guest list,” Fallon said. “His parents arrived yesterday, and tonight they’re going over it to finalize everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "25",
      "id": "pg_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“It will be good seeing Uncle Leo and Aunt Gladys again. When we talked last night, they sounded just as happy as always,” Lance mused. “I bet they never thought they’d come home to find Richard planning his wedding.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon’s brow lifted. “You sound as if you never expected him to get married.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Marriage isn’t for everyone,” Lance said, the amusement gone from his face.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe not for everyone, but I’m glad I found Faith,” Brandon told them. “Enjoy your dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon picked up a taco but watched Lance. If she didn’t miss her guess, there was a certain woman in Lance’s past and it hadn’t ended pretty. Fallon continued eating for a bit but couldn’t resist asking, “You don’t approve of Richard marrying?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I never said that.” He polished off his steak and shoved the plate aside, his annoyance obvious. “I haven’t gotten a chance to know Naomi very well, but she appears sweet and loving. Exactly the type of woman for Richard.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was on the tip of Fallon’s tongue to ask Lance about the type of woman he thought suitable for him, but thankfully she caught herself before blurting it out. “Yes, she is and, after what she went through with her first marriage and a few days ago, she deserves to be happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Richard will see to that, and that her ex never bothers her again,” Lance said with a hint of anger in his voice. Any man who hit a woman was scum—no matter the provocation. For all the hurt "), _c('span', {
    attrs: {
      "aria-label": "26",
      "id": "pg_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Ashley had put him though, physically harming her had never entered his mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He picked up his glass and saw Fallon watching him with those bedroom eyes of hers. She was trying to figure him out. He’d also caught her watching him during dinner. She was still interested in him. If he was honest, he was more than interested in her. But if things went further, she had to know it would be purely physical. No emotional involvement or happily ever after.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What about you?” he asked abruptly. Fallon might be the kind of woman who wanted forever.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She straightened, her tempting breasts jutting forward. Lance tried not to stare and worked not to let his body go into overdrive. Nothing was happening tonight—if ever.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I beg your pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What’s your view on marriage or are you engaged already?” he asked, irrationally angry at the thought of her marrying anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I fully intend to marry one day and have a family, but it’s difficult with traveling so much,” she told him. “I’m seldom in one place longer than a few months. Hardly long enough to have a lasting relationship with anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So, she wanted forever. That left him out. Even without traveling, lasting relationships were difficult. He should know. “Would you like coffee or dessert?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“If I eat another bite I might pop.” She wrinkled her nose. ‘”I’ll have to get the cheesecake another time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Lance signaled the waiter. “The bill, and please add a slice of cheesecake in a to-go container for the lady.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Certainly, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon reached for her purse. “My invitation. My treat.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“My reservation.” He reached for the bill presenter as soon as the waiter approached. Lance barely glanced at it before shoving a large bill inside and handing it back to the waiter. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Thank you, sir, and a good evening to both of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It would be better if it ended with both of them in a bed, but that wasn’t happening. Lance stood, picked up the to-go container for the cheesecake, and reached for her chair. “I’ll walk you to your car.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon came to her feet and glanced at him over her shoulder. “That’s not necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Since I plan to follow you home, I think it is.”")]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("Fallon kept looking in the rearview mirror. First dates—if they went well—usually ended with a good-night kiss. But considering theirs had started out as a business/thank-you, Fallon wasn’t sure what to expect at the door. Lance had certainly sent out mixed signals. She couldn’t get a handle on him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For once, the parking spot in front of her door was vacant. She pulled in next to Naomi’s SUV. There was a light on in both of their apartments, but since it was barely eight thirty Fallon was sure Naomi and Richard were still at his parents’ place.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "28",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Shutting off the motor, Fallon got out of her car with the cheesecake and searched the parking lot for Lance. She saw him seconds later. It was easy to pick out his muscular build, the easy stride of his walk. He appeared self-assured, but there was something there that she couldn’t quite put her finger on. With her leaving at the end of the week, she wouldn’t have time to figure out what.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sorry to keep you waiting. I couldn’t find a parking space.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s all right,” she said, horrified to hear the breathlessness in her voice. She quickly reached into her bag for her key and turned to open the door. It opened on the first try despite her shaking hand.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Most women have to search for a key.” Lance shoved his hands into the pockets of his dress slacks. “I should have known you’re too smart for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Comes from traveling and moving so many times,” she said. Then she faced him and took the plunge. “Would you like to come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I should get back,” he told her, his expression bland. “There’s still a lot of paperwork and tagging to be done before the auction.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She honestly didn’t know if she was disappointed or not. Starting something with Lance might feel good, but she wasn’t sure it would be good for her. “Good night, and thanks for today and dinner tonight. And this.” She held up the dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re welcome. Good night.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She entered her apartment and couldn’t help one long, last tempting look at him. She’d see him at Richard and Naomi’s wedding, but somehow Fal"), _c('span', {
    attrs: {
      "aria-label": "29",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("lon knew if she and Lance didn’t connect now they never would. She started to swing the door shut.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The flat of his hand stopped it. His hand flexed on the door as if he wasn’t sure of himself. “It goes without saying that if you want to come out to the house again, you’re welcome. I’ll be working there all day tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon couldn’t keep the wide grin off her face. “I’ll be there the same time. I want to write up my notes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll see you then.” Reaching out, he closed the door.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon threw the dead bolt and headed to her bedroom. She hadn’t gotten the kiss, but tomorrow was another day.")]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("Fallon woke up with a smile on her face. She didn’t even think of denying it was because she was going to see Lance. He intrigued her as much as he made her want to take a bite out of him. Laughing, Fallon bounded out of bed and hit the shower. She’d never had such a crazy thought in her life.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Twenty-three minutes later, she was knocking on Naomi’s back door. In Fallon’s hands were two mugs. One held a mixture of coffee creamer and sugar. The other mug was empty. She might bum coffee, but she always came with what she wanted in it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was seven ten, but Fallon knew her neighbor and friend would be up and alone. Naomi taught kindergarten and would be up getting ready for work. And since her ex was no longer a threat, Richard wouldn’t be spending the night.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "30",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Fallon heard the locks disengage seconds before the door opened. “Good morning,” Naomi greeted. “Help yourself to coffee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Bless you.” From long practice, Fallon prepared herself a cup of coffee, then sipped.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I fixed extra waffle batter,” Naomi said. “If you hurry you can tell me about your date before Kayla joins us.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Taking another sip, Fallon went to the stove to check on the sizzling sausage patties. She picked up a metal spatula. “Nothing to tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Naomi closed the lid to the waffle maker and faced Fallon with a frown. “Richard said he asked about you a couple of times before you went out there yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That was then and this is now, as the saying goes.” Fallon lifted two turkey patties from the skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The whistle of the waffle machine sounded. Naomi removed the waffle and added more batter. “How do you feel about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m leaving at the end of the week.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Don’t remind me.” Taking the spatula from Fallon’s hand, Naomi removed the other patties. “If you weren’t coming back for the wedding in six weeks, I’m not sure I could stand it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon hugged her, then leaned her head against hers. “Same here. Like I said, the apartment gods were smiling on me this time. It’s been great living next door to you these months.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Naomi straightened. “You and Catherine helped me stop being afraid and reach out for Richard. "), _c('span', {
    attrs: {
      "aria-label": "31",
      "id": "pg_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("You’ve been wonderful with Kayla. I’d say it was the other way around.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah, it’s been nice.” Fallon removed the waffle when the alarm sounded. “Mama and Megan are anxious to have me home before I leave for my next assignment.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Taking the platters of meat and waffles, Naomi placed them on the kitchen table. “If you weren’t leaving, would it make a difference with things between you and Lance?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m not sure.” Fallon sipped her coffee. “Bad timing. I’m going out there today to take more notes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Then there’s still a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fallon shook her head. “Lance is a hard man to read.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Naomi placed another plate on the table. “So it will take more effort. Won’t the end results be worth it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All Fallon had to do was think of the searing look Lance had given her the night before. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Then go get him.”")]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("Late Tuesday afternoon Lance finally heard the sound that he had waited all day to hear, the chime of the doorbell. So, she had finally come—if it was her. She was almost two hours later than the day before. He’d begun to worry about her fifteen minutes past the time he thought she should be there.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Bad. Very bad.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No matter how much he told himself to keep it professional, some part of him—the stubborn part "), _c('span', {
    attrs: {
      "aria-label": "32",
      "id": "pg_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("that had helped him succeed in business if not his personal life—wasn’t listening. He’d almost called Richard to check on her, then reasoned that if something had happened Richard would have notified him.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If Richard knew.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lance threw his pen on the desk and came to his feet. He hadn’t done a solid ten minutes of work all day. Women messed up a man’s orderly life. He knew that better than most. Yet—")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A knock came on his office door. “Mr. Saxton, your guest, Ms. Marshall, is here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Relief, excitement, uneasiness—so many emotions crowded Lance’s brain he couldn’t sort all of them out. He’d never been this conflicted about a woman or anything else in his life. He tended to see things in black and white—no gray—since the year his mother had married another man and made Lance feel like an outsider in his own home.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Mr. Saxton?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Letting go of the resentment, Lance unclenched his fists. The past needed to stay in the past. “Come in.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The door opened. He caught a brief glimpse of Carmen, his housekeeper; then Fallon stepped into the room and she became his entire focus.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She was stunningly beautiful and off-limits. Before he knew it, he was moving. He didn’t ask or hesitate; he just took her into his arms, his mouth finding hers. He expected a mild resistance—which he was fully prepared to overcome. What he didn’t expect was for her to melt in his arms, to soften "), _c('span', {
    attrs: {
      "aria-label": "33",
      "id": "pg_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("and wrap her arms around his neck, letting her sleek, elegant body mold itself against him. He was a bit shocked by his behavior, but passion was stronger than caution.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Heat and desire shot through his veins. He took the kiss deeper, his tongue thrusting and sliding across hers and feasted off her incredible soft, sweet mouth as one hand swept down her elegant back. Finally he lifted his head and swept his mouth across hers, intending to kiss her again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s some hello,” she said, but her voice trembled as much as she did in his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He couldn’t recall a woman being that shaken by a kiss, but staring down into Fallon’s deep brown eyes, he had the feeling again that she was different—and therefore more dangerous to his peace of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Still, his thumb traced over the dampness of her lower lip. Before now he would have thought himself a cautious man—life had made him that way. Yet—“I regretted I didn’t kiss you last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So did I,” she admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His head dipped. She pushed out of his arms. He let her go—for now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m leaving Sunday on the seven-thirty morning flight to Austin,” she said, her voice steady, her gaze direct. “I don’t do affairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He believed her. His bad luck with women was holding. After three years of going through the motions, he’d finally met a woman he’d like to get to know better out of bed and she wasn’t available. “I wish you weren’t a woman of principle.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "34",
      "id": "pg_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("She tilted her head to one side. “Which means you’ve been around the wrong type of women.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Since she was right, he didn’t comment, just went to stand behind his desk. He needed to put some distance between them. “You’re late.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Naomi’s coworkers gave her a surprise bridal shower after school. I went to pick up Kayla.” Fallon grinned, quick and easy. “The principal was concerned that some of the gifts might be of the adult variety, and she was right. I’m here now.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So you are.” He took a seat and picked up his pen. “They’re still doing inventory, but feel free to roam and take pictures.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her eyes widened, her hand went to her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He came out of his seat and crossed to her. “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her gaze went to him, then skittered away.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He’d seen that evasive look from women too many times in his life. He’d hoped never to see it again. He started for his desk. “I won’t keep you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I was hurrying and forgot my camera,” she said softly, but he heard and swung back around.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“At your apartment?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Folding her arms, she looked out the window over his shoulder. “The car.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He stared at her. She’d been that anxious to see him?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Don’t get the big head,” she told him, lowering her arms. “The house has a lot of appeal as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, it does.” Not only could he get a big head, but he also could lose it over the woman with a "), _c('span', {
    attrs: {
      "aria-label": "35",
      "id": "pg_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("half smile on alluring lips whom he was beginning to crave.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I better get to it.” She went to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Do you have any plans for dinner?” he asked, hoping to sound casual.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She wrinkled her pretty nose. “Two-day-old spaghetti.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I think I can do better than that,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You cooking?” Folding her arms, she leaned against the door.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Not one of my talents,” he told her. “Fortunately, Carmen is an excellent cook, although I’m not sure what’s on the menu tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His brow lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She flushed. “I meant—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Believe me, I know full well what you meant.” The laugh just slipped out. It was rare to see a woman blush, even rarer to laugh in the company of one.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Eyes narrowed, she came away from the door. “You’re laughing at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It would seem.” He pulled a folder closer to him. “Carmen prepares dinner for me before she leaves at six. Usually it’s something I can reheat since I have a tendency to get buried in my work, so any time after six we can eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She returned to the door. “I can get involved as well. One or the other of us will come find the other if the other gets hungry.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ah, I think I understood that,” he said, smiling. She really was fun.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "aria-label": "36",
      "id": "pg_36",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("She grinned. “Later.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The door closed and Lance stared after her, his smile slowly fading. Fallon Marshall was proving to be more than a pretty face and incredible body. He just hoped she was as open and as honest as she appeared.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 69
// module chunks = 0